import { UpLg } from "./UpLg";
import { UpSm } from "./UpSm";
import { UpXs } from "./UpXs";

export default { UpLg, UpSm, UpXs};